import * as React from 'react';
import { Route } from 'react-router';

import { Route as CourseraRoute } from '@coursera/react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import NotFound from 'bundles/phoenix/components/NotFound';
import { CONSUMER_SEARCH_ROUTE } from 'bundles/search-common/constants';
import SearchApp from 'bundles/search-v2/components/SearchV2Application';

const SearchPageRoot = loadOnRoute(() => import('bundles/search-v2/components/SearchPageRoot'));

export default (
  <CourseraRoute
    path="/"
    component={SearchApp}
    handle={{
      tracking: {
        data: (_, location) => {
          const currentPage = location?.query?.page;

          return {
            page: {
              segment: 'consumer',
              type: 'search_result_page',
              pagination: {
                pageNumber: currentPage ? Number(currentPage) : 1,
              },
            },
          };
        },
      },
    }}
  >
    <Route path={CONSUMER_SEARCH_ROUTE} getComponent={SearchPageRoot} />
    <Route path="search-v2" getComponent={SearchPageRoot} />
    <Route path="*" component={NotFound} />
  </CourseraRoute>
);
